<template>
    <CFormGroup :error="error">
        <CFormCheckbox :required="required" :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
            {{ message }}
            <NuxtLink class="link" target="_blank" :to="{ name: 'ochrana-sukromia' }">{{ linkText }}</NuxtLink>
            <CTooltip>
                {{ tooltip }}
            </CTooltip>
            <span v-html="slovakPrivacyPageWarning"></span>
        </CFormCheckbox>
    </CFormGroup>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { Agreement } from '#shared/types/Agreement'
import type { Org } from '#shared/types/Org'

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false
    },
    agreement: {
        type: Object as PropType<Agreement>,
        required: true
    },
    org: {
        type: Object as PropType<Org>,
        required: true
    },
    required: {
        type: Boolean,
        default: false
    },
    error: {
        type: String,
        default: undefined
    },
    lang: {
        type: String,
        default: 'sk'
    }
})

defineEmits(['update:modelValue'])

const { t: $t, t } = useI18n()
const keyPrefix = 'jobView.sendJobModal.fields.jobApplicationConsent'

const message = computed((): string => {
    const orgTitle = props.org.title
    const wording = t(`${keyPrefix}.wording`, { orgTitle }) as string
    return wording.replace('{orgTitle}', orgTitle)
})

const linkText = computed((): string => {
    return String(t(`${keyPrefix}.linkText`))
})

const tooltip = computed((): string => {
    return String(t(`${keyPrefix}.tooltip`))
})

const slovakPrivacyPageWarning = computed((): string => {
    return props.lang === 'en' ? '<br /><em>(only in Slovak)</em>' : ''
})
</script>
